import { useSortable } from '@dnd-kit/sortable';
import { CSS, Transform } from '@dnd-kit/utilities';
import Box from '@mui/material/Box';
import type { SxProps } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';

import { PropsWithChildren, Sxable } from 'library/types';

import { DragHandler } from './DragHandler';

export interface DraggableProps {
	id: string;
	transform?: keyof Transform;
}

const dragHandlerStyle: SxProps<Theme> = (theme: Theme) => ({
	position: 'absolute',
	left: theme.spacing(0.5),
});

export const Draggable = ({
	children,
	id,
	sx = {},
	transform: transformKey,
}: DraggableProps & Sxable & PropsWithChildren) => {
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({ id });

	const finalSx = {
		...sx,
		position: 'relative',
		transform:
			transformKey && transform
				? `translate(${transform[transformKey]}px)`
				: CSS.Transform.toString(transform),
		transition,
		zIndex: isDragging ? 1 : 0,
	} as SxProps;

	return (
		<Box sx={finalSx} ref={setNodeRef}>
			{children}
			<DragHandler sx={dragHandlerStyle} {...listeners} {...attributes} />
		</Box>
	);
};
